"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelSources = void 0;
exports.modelSources = [
    {
        name: 'donutsModel',
        type: 'gltfModel',
        path: 'static/donuts/donuts.gltf'
    }
];
